import request from '@/utils/request'


// 查询被保人列表
export function listInsured(query) {
  return request({
    url: '/insured/insured/list',
    method: 'get',
    params: query
  })
}

// 查询被保人分页
export function pageInsured(query) {
  return request({
    url: '/insured/insured/page',
    method: 'get',
    params: query
  })
}

// 查询被保人详细
export function getInsured(data) {
  return request({
    url: '/insured/insured/detail',
    method: 'get',
    params: data
  })
}

// 新增被保人
export function addInsured(data) {
  return request({
    url: '/insured/insured/add',
    method: 'post',
    data: data
  })
}

// 修改被保人
export function updateInsured(data) {
  return request({
    url: '/insured/insured/edit',
    method: 'post',
    data: data
  })
}

// 删除被保人
export function delInsured(data) {
  return request({
    url: '/insured/insured/delete',
    method: 'post',
    data: data
  })
}
